// extracted by mini-css-extract-plugin
export default {"title":"Text_title__OTC7I","subtitle":"Text_subtitle__LkDFu","text":"Text_text__hbYTF"};